import type { StudentResource } from '@backend/agents-ui-api/resources/students/types'
import type { GetStudentResponse } from '@backend/agents-ui-api/routes/students/{studentId}/GET/types'

import { ApiAgentRequest, request } from '../utils'

import { useAuthQuery } from './auth'

export type Student = StudentResource

type GetStudentProps = {
  id?: string
}

export function useGetStudent({ id }: GetStudentProps) {
  const { isLoading, data } = useAuthQuery(
    ['students', id],
    async () => {
      return request<GetStudentResponse>(
        new ApiAgentRequest(`/students/${id}`, {
          method: 'GET',
        }),
        {
          isExpectedResponse: (res): res is GetStudentResponse => res as boolean,
        },
      )
    },
    {
      refetchOnMount: true,
      enabled: !!id,
    },
  )

  return {
    isLoadingStudent: isLoading,
    student: data?.data,
  }
}